import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface LeaveConfirmationDialogData {
  title?: string;
  message?: string;
  stayLabel?: string;
  leaveLabel?: string;
}

@Component({
  selector: "app-leave-confirmation-dialog",
  templateUrl: "./leave-confirmation-dialog.component.html",
  styleUrls: ["./leave-confirmation-dialog.component.scss"],
})
export class LeaveConfirmationDialogComponent {
  title: string;
  message: string;
  stayLabel: string;
  leaveLabel: string;

  constructor(
    public dialogRef: MatDialogRef<LeaveConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LeaveConfirmationDialogData
  ) {
    this.title = data?.title || "Unsaved changes";
    this.message =
      data?.message ||
      "You have unsaved changes. If you leave now your changes will be lost.";
    this.stayLabel = data?.stayLabel || "Stay";
    this.leaveLabel = data?.leaveLabel || "Leave";
  }

  stay(): void {
    this.dialogRef.close(false);
  }

  leave(): void {
    this.dialogRef.close(true);
  }
}
